export class ReportParaFilter {
    FromMonth: string | null = null;
    FromYear: string | null = null;
    ToMonth: string | null = null;
    ToYear: string | null = null;
    Status: string | null = null;
    Area: string | null = null;
    Detail: string | null = null;
    Principal: string | null = null;
    CustCode: string | null = null;
    CustName: string | null = null;
    ItemCode: string | null = null;

    set(item: any) {
        this.FromMonth = item.FromMonth;
        this.FromYear = item.FromYear;
        this.ToMonth = item.ToMonth;
        this.ToYear = item.ToYear;
        this.Status = item.Status;
        this.Area = item.Area;
        this.Detail = item.Detail;
        this.Principal = item.Principal;
        this.CustCode = item.CustCode;
        this.CustName = item.CustName;
        this.ItemCode = item.ItemCode;
    }
}
